"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Types_1 = require("../../../../../Types");
var reactstrap_1 = require("reactstrap");
var AuthenticationService_1 = require("../../../../../Services/AuthenticationService");
var Util_1 = require("../../../../../Services/Util");
var Components_1 = require("../../../../../Components");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var EventHandlerService_1 = require("../../../../../Services/EventHandlerService");
require("../Styles/AddArvatoLocationEventContent.css");
var AddArvatoLocationEventContentState;
(function (AddArvatoLocationEventContentState) {
    AddArvatoLocationEventContentState[AddArvatoLocationEventContentState["Initial"] = 0] = "Initial";
    AddArvatoLocationEventContentState[AddArvatoLocationEventContentState["Certificate"] = 1] = "Certificate";
    AddArvatoLocationEventContentState[AddArvatoLocationEventContentState["TAN"] = 2] = "TAN";
    AddArvatoLocationEventContentState[AddArvatoLocationEventContentState["File"] = 3] = "File";
    AddArvatoLocationEventContentState[AddArvatoLocationEventContentState["Pass"] = 4] = "Pass";
    AddArvatoLocationEventContentState[AddArvatoLocationEventContentState["Pending"] = 5] = "Pending";
    AddArvatoLocationEventContentState[AddArvatoLocationEventContentState["Success"] = 6] = "Success";
    AddArvatoLocationEventContentState[AddArvatoLocationEventContentState["Error"] = 7] = "Error";
})(AddArvatoLocationEventContentState || (AddArvatoLocationEventContentState = {}));
var CertInputType;
(function (CertInputType) {
    CertInputType[CertInputType["unset"] = 0] = "unset";
    CertInputType[CertInputType["TAN"] = 1] = "TAN";
    CertInputType[CertInputType["File"] = 2] = "File";
})(CertInputType || (CertInputType = {}));
var AddArvatoLocationEventContent = /** @class */ (function (_super) {
    __extends(AddArvatoLocationEventContent, _super);
    function AddArvatoLocationEventContent(props) {
        var _this = _super.call(this, props) || this;
        _this.clearValidation = function () {
            var locationDataValidation = _this.state.LocationDataValidation;
            Object.values(locationDataValidation).forEach(function (v) { return v.reset(); });
            _this.setState({ LocationDataValidation: locationDataValidation });
        };
        _this.validateInputs = function () {
            var validationData = _this.state.LocationDataValidation;
            Object.keys(validationData).forEach(function (key) { validationData[key].validate(_this.state.LocationData[key]); });
            _this.setState({ LocationDataValidation: validationData });
            return Object.values(validationData).every(function (v) { return !v.isInvalid(); });
        };
        _this.getLocationData = function () {
            return _this.state.LocationData;
        };
        _this.updateLocationData = function (event, propName) {
            var _a;
            _this.setState({
                LocationData: __assign(__assign({}, _this.state.LocationData), (_a = {}, _a[propName] = event.target.value, _a))
            }, function () {
                var _a;
                _this.setState({
                    LocationDataValidation: __assign(__assign({}, _this.state.LocationDataValidation), (_a = {}, _a[propName] = _this.state.LocationDataValidation[propName].validate(_this.state.LocationData[propName]), _a))
                });
            });
        };
        _this.updateTan = function (event) {
            _this.setState({ TAN: event.target.value }, function () { _this.setState({ TanValidation: _this.state.TanValidation.validate(_this.state.TAN) }); });
        };
        _this.updateCertFile = function (event) {
            //console.log(event.target.value)
            var files = event.target.files;
            if (!files || !files.length) {
                return;
            }
            if (!event.target.value.match(/(.pfx|.p12)+$/g)) {
                _this.setState({ ApplicationValidation: new Types_1.Validation(_this.props.applicationData.resources.Upload_WrongFormat, Types_1.InputValidationState.invalid) });
                return;
            }
            var file = files[0];
            var reader = new FileReader();
            reader.onloadend = function (event) {
                var _a;
                //console.log(event.target?.result);
                _this.setState({ CertFile: (_a = event.target) === null || _a === void 0 ? void 0 : _a.result }, function () { return _this.updateModal(AddArvatoLocationEventContentState.Pass); });
            };
            reader.readAsDataURL(file);
        };
        _this.updateCertPassPhrase = function (event) {
            _this.setState({ CertPassPhrase: event.target.value }, function () { _this.setState({ TanValidation: _this.state.TanValidation.validate(_this.state.TAN) }); });
        };
        _this.updateValidation = function (validationResponse) {
            _this.clearValidation();
            var locationDataValidation = _this.state.LocationDataValidation;
            if (validationResponse.name == "SetupLocations_CannotAddDuplicateLocations" || validationResponse.name == "SetupLocations_LocationInvalidCharacters") {
                locationDataValidation.Name.Validation = new Types_1.Validation(_this.props.applicationData.resources[validationResponse.name], Types_1.InputValidationState.invalid);
                _this.setState({ LocationDataValidation: locationDataValidation });
            }
            else if (validationResponse.name == "SetupLocations_CannotAddDuplicateClientId") {
                locationDataValidation.UserId.Validation = new Types_1.Validation(_this.props.applicationData.resources[validationResponse.name], Types_1.InputValidationState.invalid);
                _this.setState({ LocationDataValidation: locationDataValidation });
            }
            else {
                _this.setState({ ApplicationValidation: { Error: _this.props.applicationData.resources[validationResponse.name || validationResponse], State: Types_1.InputValidationState.invalid } });
            }
        };
        _this.addLocation = function () { return __awaiter(_this, void 0, void 0, function () {
                   var location, options, json, endpoint, userRequestHeaders, headers;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            location = this.getLocationData();
                            this.updateModal(AddArvatoLocationEventContentState.Pending);
                            options = {};
                            options = Object.assign(__assign({}, Util_1.defaultPostOptions), options);
                            if (this.state.Status == AddArvatoLocationEventContentState.TAN) {
                                json = JSON.stringify(__assign(__assign({}, location), { Tan: this.state.TAN }));
                                endpoint = "api/Location/AddArvatoLocationWithTan";
                            }
                            else {
                                json = JSON.stringify(__assign(__assign({}, location), { Cert: this.state.CertFile, Pass: this.state.CertPassPhrase }));
                                endpoint = "/api/Location/AddArvatoLocationWithCertificate";
                            }
                            options = __assign(__assign({}, options), { body: json });
                            userRequestHeaders = new Util_1.UserRequestHeaders(AuthenticationService_1.Auth.getUser());
                            headers = new Headers(options.headers);
                            return [4 /*yield*/, AuthenticationService_1.Auth.getAccessToken().then(function (token) {
                                headers.append("Authorization", "Bearer " + token);
                                options.headers = headers;
                            }).catch(function (error) {
                                console.error("Error adding auth header: " + error);
                            })];
                        case 1:
                            _a.sent();
                            userRequestHeaders.AppendHeaders(options);
                            fetch(endpoint, options).then(function (response) {
                                if (!response.ok) {
                                    response.json().then(function (validationResponse) {
                                        _this.clearValidation();
                                        if (validationResponse.name == "AddLocation_WrongCertPass") {
                                            var certPassValidation = _this.state.CertPassPhraseValidation;
                                            certPassValidation.Validation = new Types_1.Validation(_this.props.applicationData.resources[validationResponse.name], Types_1.InputValidationState.invalid);
                                            _this.setState({ CertPassPhraseValidation: __assign({}, _this.state.CertPassPhraseValidation) }, function () { return _this.updateModal(AddArvatoLocationEventContentState.Pass); });
                                        }
                                        else {
                                            _this.setState({ ApplicationValidation: { Error: _this.props.applicationData.resources[validationResponse.name], State: Types_1.InputValidationState.invalid } }, function () { return _this.updateModal(AddArvatoLocationEventContentState.Error); });
                                        }
                                    });
                                }
                                else {
                                    _this.updateModal(AddArvatoLocationEventContentState.Success);
                                }
                            }).catch(function (err) {
                                _this.updateModal(AddArvatoLocationEventContentState.Error);
                                console.error("Error adding new location:");
                                console.error(err);
                            });
                            return [2 /*return*/];
                    }
                });
           }); };
        _this.next = function () { return __awaiter(_this, void 0, void 0, function () {
                var location, options, checkLocationData, json, userRequestHeaders, headers;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.clearValidation();
                            if (!this.validateInputs()) {
                                return [2 /*return*/];
                            }
                            location = this.getLocationData();
                            this.updateModal(AddArvatoLocationEventContentState.Pending);
                            options = {};
                            options = Object.assign(__assign({}, Util_1.defaultPostOptions), options);
                            checkLocationData = { name: location.Name, uniqueId: location.UserId };
                            json = JSON.stringify(checkLocationData);
                            options = __assign(__assign({}, options), { body: json });
                            userRequestHeaders = new Util_1.UserRequestHeaders(AuthenticationService_1.Auth.getUser());
                            headers = new Headers(options.headers);
                            return [4 /*yield*/, AuthenticationService_1.Auth.getAccessToken().then(function (token) {
                                headers.append("Authorization", "Bearer " + token);
                                options.headers = headers;
                            }).catch(function (error) {
                                console.error("Error adding auth header: " + error);
                            })];
                        case 1:
                            _a.sent();
                            userRequestHeaders.AppendHeaders(options);
                            fetch("/api/Location/Check", options).then(function (response) {
                                if (!response.ok) {
                                    _this.updateModal(AddArvatoLocationEventContentState.Initial);
                                    response.json().then(function (validationResponse) {
                                        _this.updateValidation(validationResponse);
                                    });
                                }
                                else {
                                    _this.updateModal(AddArvatoLocationEventContentState.Certificate);
                                }
                            }).catch(function (err) {
                                _this.updateModal(AddArvatoLocationEventContentState.Error);
                                console.error("Error adding new location:");
                                console.error(err);
                            });
                            return [2 /*return*/];
                    }
                });
            }); };
        _this.updateModal = function (newState) {
            _this.setState({ Status: newState });
            switch (newState) {
                case AddArvatoLocationEventContentState.Success:
                    if (AuthenticationService_1.Auth.getUser().Location == null || AuthenticationService_1.Auth.getUser().Location == undefined || AuthenticationService_1.Auth.getUser().Location == "undefined") {
                        sessionStorage.setItem(AuthenticationService_1.AuthenticationService.selectedLocationKey, _this.state.LocationData.Name);
                        _this.props.updateCallback(_this.state.LocationData.Name);
                    }
                    _this.props.updateCallback();
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.applicationData.resources.Success;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Finish, "primary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
                case AddArvatoLocationEventContentState.Error:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.applicationData.resources.Error;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
                case AddArvatoLocationEventContentState.Pending:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.applicationData.resources.LoadingDotDotDot;
                    event.actions = [];
                    eventHandler.UpdateEvent();
                    break;
                case AddArvatoLocationEventContentState.Initial:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.applicationData.resources.CreateLocation_Heading;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.SetupLocations_AddLocation, "primary", function (currentEvent, closeModalCallback) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    this.next();
                                    return [2 /*return*/];
                                });
                            }); }), new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
                case AddArvatoLocationEventContentState.Certificate:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.applicationData.resources.CreateLocation_Heading;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.SetupLocations_AddLocation, "primary", function (currentEvent, closeModalCallback) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    if (this.state.selectedCertInputType != CertInputType.unset) {
                                        this.updateModal(this.state.selectedCertInputType == CertInputType.TAN ? AddArvatoLocationEventContentState.TAN : AddArvatoLocationEventContentState.File);
                                    }
                                    return [2 /*return*/];
                                });
                            }); }), new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
                case AddArvatoLocationEventContentState.TAN:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.applicationData.resources.CreateLocation_Heading;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.SetupLocations_AddLocation, "primary", function (currentEvent, closeModalCallback) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    this.addLocation();
                                    return [2 /*return*/];
                                });
                            }); }),
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    break;
                case AddArvatoLocationEventContentState.File:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.applicationData.resources.CreateLocation_Heading;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
                case AddArvatoLocationEventContentState.Pass:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.applicationData.resources.CreateLocation_Heading;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.SetupLocations_AddLocation, "primary", function (currentEvent, closeModalCallback) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    this.addLocation();
                                    return [2 /*return*/];
                                });
                            }); }),
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
            }
        };
        _this.changeCertInputType = function (newSelectedType) {
            var _a, _b;
            if (_this.state.selectedCertInputType != newSelectedType) {
                _this.setState({ selectedCertInputType: newSelectedType });
            }
            (_a = _this.certFileButtonRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            (_b = _this.tanButtonRef.current) === null || _b === void 0 ? void 0 : _b.blur();
        };
        _this.state = {
            LocationData: {},
            LocationDataValidation: {
                Name: new Types_1.InputValidation(true, props.applicationData.resources.ValidationError_LocationNameInvalid, /^\S+.{1,}\S$/),
                ClientId: new Types_1.InputValidation(true, props.applicationData.resources.ValidationError_ClientIdInvalid, /^[a-zA-Z]{3,30}$/),
                UserId: new Types_1.InputValidation(true, props.applicationData.resources.ValidationError_UserIdInvalid, /^[a-zA-Z0-9]{6,30}$/),
                Password: new Types_1.InputValidation(),
                Type: new Types_1.InputValidation()
            },
            Status: AddArvatoLocationEventContentState.Initial,
            ApplicationValidation: new Types_1.Validation(),
            ShowPassword: false,
            TAN: "",
            TanValidation: new Types_1.InputValidation(true, props.applicationData.resources.ValidationError_TANInvalid, /^[a-zA-Z0-9]{6,10}$/),
            selectedCertInputType: CertInputType.unset,
            CertFile: "",
            CertFileValidation: new Types_1.InputValidation(),
            CertPassPhrase: "",
            CertPassPhraseValidation: new Types_1.InputValidation()
        };
        _this.tanButtonRef = React.createRef();
        _this.certFileButtonRef = React.createRef();
        return _this;
    }
    AddArvatoLocationEventContent.prototype.render = function () {
        var _this = this;
        var _a, _b;
        switch (this.state.Status) {
            case AddArvatoLocationEventContentState.Initial:
                return (React.createElement("div", null,
                    React.createElement("div", { id: "create_location_message" }, this.props.applicationData.resources.Create_Location_Arvato),
                    React.createElement(reactstrap_1.InputGroup, { className: "my-3" },
                        React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                            React.createElement(reactstrap_1.InputGroupText, null,
                                this.props.applicationData.resources.Name,
                                " ")),
                        React.createElement(reactstrap_1.Input, { valid: this.state.LocationDataValidation.Name.isValid(), invalid: this.state.LocationDataValidation.Name.isInvalid(), onChange: function (e) { return _this.updateLocationData(e, "Name"); }, value: this.state.LocationData.Name }),
                        React.createElement(reactstrap_1.FormFeedback, { style: { textAlign: "right" } }, this.state.LocationDataValidation.Name.isInvalid() ? this.state.LocationDataValidation.Name.Validation.Error : "")),
                    React.createElement(reactstrap_1.InputGroup, { className: "my-3" },
                        React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                            React.createElement(reactstrap_1.InputGroupText, null,
                                "User name",
                                " ")),
                        React.createElement(reactstrap_1.Input, { valid: this.state.LocationDataValidation.ClientId.isValid(), invalid: this.state.LocationDataValidation.ClientId.isInvalid(), onChange: function (e) { return _this.updateLocationData(e, "ClientId"); }, value: this.state.LocationData.ClientId }),
                        React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend", style: { marginLeft: "-1px" } },
                            React.createElement(reactstrap_1.InputGroupText, null,
                                "/",
                                " ")),
                        React.createElement(reactstrap_1.Input, { valid: this.state.LocationDataValidation.UserId.isValid(), invalid: this.state.LocationDataValidation.UserId.isInvalid(), onChange: function (e) { return _this.updateLocationData(e, "UserId"); }, value: this.state.LocationData.UserId }),
                        React.createElement(reactstrap_1.FormFeedback, { style: { textAlign: "right" } }, this.state.LocationDataValidation.UserId.isInvalid() ? this.state.LocationDataValidation.UserId.Validation.Error : "")),
                    React.createElement(reactstrap_1.InputGroup, { className: "my-3", style: { display: "flex", alignItems: "center" } },
                        React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                            React.createElement(reactstrap_1.InputGroupText, null,
                                this.props.applicationData.resources.Password,
                                " ")),
                        React.createElement(reactstrap_1.Input, { valid: this.state.LocationDataValidation.Password.isValid(), invalid: this.state.LocationDataValidation.Password.isInvalid(), onChange: function (e) { return _this.updateLocationData(e, "Password"); }, value: this.state.LocationData.Password, type: this.state.ShowPassword ? "text" : "password" }),
                        " ",
                        ((_a = this.state.LocationData.Password) === null || _a === void 0 ? void 0 : _a.length) > 0 && Util_1.saysWho().name != "IE" && React.createElement(react_fontawesome_1.FontAwesomeIcon, { onMouseDown: function () { return _this.setState({ ShowPassword: true }); }, onMouseUp: function () { return _this.setState({ ShowPassword: false }); }, icon: free_solid_svg_icons_1.faEye, className: "show-password" }),
                        React.createElement(reactstrap_1.FormFeedback, { style: { textAlign: "right" } }, this.state.LocationDataValidation.Password.isInvalid() ? this.state.LocationDataValidation.Password.Validation.Error : "")),
                    React.createElement(reactstrap_1.InputGroup, { className: "my-3", style: { display: "flex", alignItems: "center" } },
                        React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                            React.createElement(reactstrap_1.InputGroupText, null,
                                this.props.applicationData.resources.Type,
                                " ")),
                        React.createElement(reactstrap_1.Input, { type: "select", valid: this.state.LocationDataValidation.Type.isValid(), invalid: this.state.LocationDataValidation.Type.isInvalid(), onChange: function (e) { return _this.updateLocationData(e, "Type"); }, value: this.state.LocationData.Type },
                            React.createElement("option", { key: "default", hidden: true }, this.props.applicationData.resources.PleaseSelectALocationType),
                            React.createElement("option", { key: "Pharmacist", value: "Pharmacist" }, this.props.applicationData.resources.Pharmacist),
                            React.createElement("option", { key: "Wholesaler", value: "Wholesaler" }, this.props.applicationData.resources.Wholesaler)),
                        React.createElement(reactstrap_1.FormFeedback, { style: { textAlign: "right" } }, this.state.LocationDataValidation.Type.isInvalid() ? this.state.LocationDataValidation.Type.Validation.Error : ""))));
            case AddArvatoLocationEventContentState.Certificate:
                return (React.createElement("div", null,
                    React.createElement("div", { id: "create_location_message", className: "my-3" }, this.props.applicationData.resources.Create_Location_Arvato_Cert),
                    React.createElement(reactstrap_1.CustomInput, { type: "radio", id: "tanRadio", name: "certradio", label: this.props.applicationData.resources.Tan, onChange: function () { return _this.setState({ selectedCertInputType: CertInputType.TAN }); } }),
                    React.createElement(reactstrap_1.CustomInput, { type: "radio", id: "fileRadio", name: "certradio", label: this.props.applicationData.resources.CertificateFile, onChange: function () { return _this.setState({ selectedCertInputType: CertInputType.File }); } })));
            case AddArvatoLocationEventContentState.TAN:
                return (React.createElement("div", null,
                    React.createElement(reactstrap_1.InputGroup, { className: "my-3" },
                        React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                            React.createElement(reactstrap_1.InputGroupText, null,
                                this.props.applicationData.resources.Tan,
                                " ")),
                        React.createElement(reactstrap_1.Input, { valid: this.state.TanValidation.isValid(), invalid: this.state.TanValidation.isInvalid(), onChange: function (e) { return _this.updateTan(e); }, value: this.state.TAN }),
                        React.createElement(reactstrap_1.FormFeedback, { style: { textAlign: "right" } }, this.state.TanValidation.isInvalid() ? this.state.TanValidation.Validation.Error : ""))));
            case AddArvatoLocationEventContentState.File:
                return (React.createElement("div", null,
                    React.createElement("div", { id: "create_location_message", className: "my-3" }, this.props.applicationData.resources.Create_Location_Arvato_Cert_File),
                    React.createElement(Components_1.Center, { horizontal: true },
                        Util_1.saysWho().name == "IE" ? //I hate IE
                            React.createElement("label", { className: "my-0", htmlFor: "cert-input", style: { cursor: "pointer" } },
                                React.createElement(reactstrap_1.Button, { outline: true, color: "primary" },
                                    React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCloudUploadAlt }),
                                    "   ",
                                    this.props.applicationData.resources.UploadCertificate))
                            :
                            React.createElement(reactstrap_1.Button, { outline: true, color: "primary" },
                                React.createElement("label", { className: "my-0", htmlFor: "cert-input", style: { cursor: "pointer" } },
                                    React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCloudUploadAlt }),
                                    "   ",
                                    this.props.applicationData.resources.UploadCertificate)),
                        React.createElement("input", { style: { display: "none" }, id: "cert-input", type: "file", onChange: this.updateCertFile, accept: ".pfx,.p12" })),
                    this.state.ApplicationValidation.isInvalid() && React.createElement(reactstrap_1.FormFeedback, { style: { display: "block" } }, this.state.ApplicationValidation.Error)));
            case AddArvatoLocationEventContentState.Pass:
                return (React.createElement("div", null,
                    React.createElement("div", { className: "my-3" }, this.props.applicationData.resources.Create_Location_PassPhrase),
                    React.createElement(reactstrap_1.InputGroup, { className: "my-3", style: { display: "flex", alignItems: "center" } },
                        React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                            React.createElement(reactstrap_1.InputGroupText, null,
                                this.props.applicationData.resources.CertificatePassphrase,
                                " ")),
                        React.createElement(reactstrap_1.Input, { valid: this.state.CertPassPhraseValidation.isValid(), invalid: this.state.CertPassPhraseValidation.isInvalid(), onChange: function (e) { return _this.updateCertPassPhrase(e); }, value: this.state.CertPassPhrase, type: this.state.ShowPassword ? "text" : "password" }),
                        " ",
                        ((_b = this.state.CertPassPhrase) === null || _b === void 0 ? void 0 : _b.length) > 0 && Util_1.saysWho().name != "IE" && React.createElement(react_fontawesome_1.FontAwesomeIcon, { onMouseDown: function () { return _this.setState({ ShowPassword: true }); }, onMouseUp: function () { return _this.setState({ ShowPassword: false }); }, icon: free_solid_svg_icons_1.faEye, className: "show-password" }),
                        React.createElement(reactstrap_1.FormFeedback, { style: { textAlign: "right" } }, this.state.CertPassPhraseValidation.isInvalid() ? this.state.CertPassPhraseValidation.Validation.Error : ""))));
            case AddArvatoLocationEventContentState.Pending:
                return (React.createElement(Components_1.Center, { horizontal: true, vertical: true },
                    React.createElement(Components_1.CustomSpinner, null)));
            case AddArvatoLocationEventContentState.Success:
                return (React.createElement("div", null,
                    React.createElement(reactstrap_1.Row, { className: "text-success mb-2" },
                        React.createElement(reactstrap_1.Col, null),
                        React.createElement(reactstrap_1.Col, { xs: "auto" },
                            React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "6x", icon: free_solid_svg_icons_1.faCheckCircle })),
                        React.createElement(reactstrap_1.Col, null)),
                    React.createElement(reactstrap_1.Row, null,
                        React.createElement(reactstrap_1.Col, null),
                        React.createElement(reactstrap_1.Col, { xs: "auto" }, this.props.applicationData.resources.AddLocationSuccessMessage),
                        React.createElement(reactstrap_1.Col, null))));
            case AddArvatoLocationEventContentState.Error:
                return (React.createElement("div", null,
                    React.createElement(reactstrap_1.Row, { className: "text-danger mb-2" },
                        React.createElement(reactstrap_1.Col, null),
                        React.createElement(reactstrap_1.Col, { xs: "auto" },
                            React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "6x", icon: free_solid_svg_icons_1.faTimesCircle })),
                        React.createElement(reactstrap_1.Col, null)),
                    React.createElement(reactstrap_1.Row, null,
                        React.createElement(reactstrap_1.Col, null),
                        React.createElement(reactstrap_1.Col, { xs: "auto" }, this.state.ApplicationValidation.Error || this.props.applicationData.resources.AnErrorHasOccurred),
                        React.createElement(reactstrap_1.Col, null))));
        }
    };
    return AddArvatoLocationEventContent;
}(React.Component));
exports.AddArvatoLocationEventContent = AddArvatoLocationEventContent;
//# sourceMappingURL=AddArvatoLocationEventContent.js.map